import type { PatientKeylockCode, PatientKeylockCodeDTO } from './patientKeylockCode.types';

export const parsePatientKeylockCodeForFE = (patientKeylockCodeDTO: PatientKeylockCodeDTO): PatientKeylockCode => ({
  keylockCode: patientKeylockCodeDTO.keylock_code || null,
});
